module.exports = __webpack_public_path__ + "ui-static/img/no-items_light.f9094ac8.svg";